<div class="title flex-row justify">
    D80 Reduction Ratio
    <mat-icon matTooltip="Calculated from aggregate D80 values for the selected duration"
        matTooltipPosition="below">
        info
    </mat-icon>
</div>

<div class="container reduction-ratio-container">
    <div class="connection-row">
        <span>{{ data.upstreamDevice.name }}</span>
        <mat-icon>arrow_forward</mat-icon>
        <span>{{ data.downstreamDevice.name }}</span>
    </div>

    <div class="d80-cards">
        <div class="d80-card">
            <span class="card-label">Upstream D80</span>
            <strong class="card-value">
                {{ data.upstreamD80 | number:'1.2-2' }}
                <small>{{ particleSizeUnit$ | async }}</small>
            </strong>
            <span class="device-name">{{ data.upstreamDevice.name }}</span>
        </div>

        <div class="d80-card">
            <span class="card-label">Downstream D80</span>
            <strong class="card-value">
                {{ data.downstreamD80 | number:'1.2-2' }}
                <small>{{ particleSizeUnit$ | async }}</small>
            </strong>
            <span class="device-name">{{ data.downstreamDevice.name }}</span>
        </div>
    </div>

    <div class="ratio-card">
        <span>Reduction Ratio</span>
        <strong>{{ data.ratio | number:'1.2-2' }} <small>: 1</small></strong>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()">Close</button>
</div>
